module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/荣誉奖杯.25d3911e.png";